const closeOtherItems = (currentItem, otherItems) => {
  otherItems.forEach(item => {
    const toggle = item.querySelector('[data-wpg-toggle-trigger]');
    const content = item.querySelector('[data-wpg-toggle-content]');

    if (toggle !== currentItem) {
      item.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      content.style.height = '0px';
    }
  });
};

export default () => {
  const toggleGroups = document.querySelectorAll('[data-wpg-toggle-group]');
  if (!toggleGroups || toggleGroups.length === 0) {
    return;
  }

  toggleGroups.forEach(group => {
    const toggleGroups = group.querySelectorAll('[data-wpg-toggle-item]');
    if (!toggleGroups || toggleGroups.length === 0) {
      return;
    }

    toggleGroups.forEach(item => {
      const toggle = item.querySelector('[data-wpg-toggle-trigger]');
      const content = item.querySelector('[data-wpg-toggle-content]');

      if (!toggle || !content) {
        return;
      }

      toggle.addEventListener('click', (e) => {
        closeOtherItems(e.currentTarget, toggleGroups);

        item.classList.toggle('is-open');

        if (item.classList.contains('is-open')) {
          content.style.height = `${content.scrollHeight}px`;
          toggle.setAttribute('aria-expanded', 'true');
        }
        else {
          content.style.height = '0px';
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
    });
  });
}
